module.exports = __webpack_public_path__ + "img/insurance-home.291baec9.svg";